<div class="container container-shadow mt-3 mb-5 py-5">
  <div *ngIf="loading" class="text-center"><i class="fas fa-fw fa-spinner fa-pulse fa-5x"></i></div>
  <div *ngIf="!loading">
    <h3 class="mb-3">
      Global Taxes -&nbsp;
      <app-badge badgeType="primary">
        {{ count }}
      </app-badge>
    </h3>
    <div class="mb-3">
      <button type="button" [disabled]="loading" (click)="loadGlobalTaxes()" class="btn btn-outline-primary">
        <i class="fas fa-sync" [ngClass]="{ 'fa-spin': loading }"></i>
      </button>
      &nbsp;
      <button type="button" (click)="openNewGlobalTax()" class="btn btn-outline-primary">
        <i class="fas fa-plus"></i>
        New Global Tax
      </button>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>Id</th>
          <th>Name</th>
          <th>Cutoff</th>
          <th>Frequency</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let globalTax of globalTaxes">
          <td>
            <a [routerLink]="'/global_taxes/' + globalTax.id + '/edit'"><i class="fas fa-pencil-alt"></i></a>
            {{ globalTax.id }}
          </td>
          <td>{{ globalTax.name_str }}</td>
          <td>{{ globalTax.cutoff || 0.0 | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
          <td>{{ globalTax.frequency }}</td>
          <td>
            <span *ngIf="globalTax.way == 'percent'">{{ globalTax.amount }}%</span>
            <span *ngIf="globalTax.way != 'percent'">{{ globalTax.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
